<template>
	<div class="activityPerson">
		<!-- 已报名信息详情 -->
		<div v-show="detailShow" style="box-sizing: border-box;padding-top: 20px;">
			<div style="margin:  0 20px;text-align: right;">
				<el-button @click="backToDetail">返回</el-button>
				<el-descriptions title="用户信息" :column="columNum" border>
					<el-descriptions-item v-for="(item,index) in applyDetail" :key="index" :label="item.label">
						<img v-if="hasImage(item.value)" :src="item.value"
							style="width: 100%;height: 200px;object-fit: contain;" alt="">
						<p v-else>{{item.value}}</p>
					</el-descriptions-item>
				</el-descriptions>
			</div>
		</div>
		<div v-show="!detailShow">
			<!-- 首页>业务平台>活动详情 -->
			<div class="brumd_card">
				<span>首页</span>>
				<span @click="replaceBack">业务平台</span>
				<span>>活动详情</span>
			</div>
			<div class="activity_body">
				<!-- 左侧栏目 -->
				<div class="activityPerson_left">
					<p v-for="(item,index) in titleList" :key="index" :class="[indexShow == index ?'activePerson':'']"
						@click="changeTab(index)">{{item.label}}
					</p>
				</div>
				<!-- 手机模式 -->
				<div class="phoneStyle">
					<p>{{meetingDetail.name}}</p>
					<img :src="meetingDetail.img" alt="">
				</div>
				<div class="phoneMode">
					<div v-for="(item,index) in titleList" :key="index"
						:class="[indexShow == index ?'phoneModeActive':'','phoneView']" @click="changeTab(index)">
						<p>{{item.label}}</p>
					</div>
				</div>
				<!-- 右侧详情 -->
				<div class="activityPerson_right">
					<!-- 基本信息 -->
					<div v-show="indexShow === 0">
						<showOne v-show="basicShow" ref="showOne" @submit="getShowOne"></showOne>
						<showTwo v-show="!basicShow" ref="showTwo" @cancenclsubmit="basicShow = $event"></showTwo>
					</div>
					<!-- 联系我们 -->
					<div v-show="indexShow === 1">
						<el-card class="box-card">
							<div v-for="(item,index) in meetingLink" :key="index" class="text item">
								<span style="display: inline-block;width: 150px;">{{item.name}}</span>
								<span style="margin-left: 20px;">{{item.type}}:</span>
								<span style="margin-left: 5px;">{{item.content}}</span>
							</div>
						</el-card>
					</div>
					<!-- 已报名信息 -->
					<div v-show="indexShow === 2">
						<!-- <el-button type="primary" style="float: right;margin: 20px 0 20px 20px;padding: 7px;">继续报名
						</el-button> -->
						<!-- 手机模式表格 -->
						<div v-if="phoneSize" class="phoneStyleTable">
							<elementTableExtend :tableData="outTable" :rule_code="rule_code" @refresh="refreshShow"
								:nameTable="outTabList"></elementTableExtend>
							<!-- <div v-for="(item,index) in outTable" :key="index" style="margin-bottom: 20px;">
								<div class="phoneTable" @click="handleClick(item,'详情')">
									<div class="phoneTable_pList">
										<p v-for="(value,name,key) in item" :key="key"
											v-show="name!=='id' && name!=='status'">{{value}}</p>
									</div>
									<span>{{item.status}}</span>
								</div>
								<div class="bottom_btnList">
									<p v-if="item.status" @click="handleClick(item,'提醒')">
										报名成功提醒
									</p>
									<p v-if="item.status && item.status === '已确认'" @click="handleClick(item,'取消报名')">
										取消报名
									</p>
									<p v-if="item.status && item.status === '未确认'" @click="handleClick(item,'确认报名')">
										确认报名
									</p>
								</div>
							</div> -->
						</div>
						<el-empty v-if="!dataShow" description="暂无数据"></el-empty>
						<elementTable v-if="!phoneSize && dataShow" ref="elementTbteam" :outTable="outTable"
							:outTabList="outTabList" @editMore="getTable">
							<el-table-column fixed="right" align="center" width="100px" header-align="center"
								label="动作">
								<template slot-scope="scope">
									<el-button @click="handleClick(scope.row,'详情')" type="text" size="small">详情
									</el-button>
									<el-button v-if="scope.row.status == '已报名'" @click="handleClick(scope.row,'取消')"
										type="text" size="small">取消
									</el-button>
									<el-button v-if="scope.row.status == '已报名'" @click="openApply(scope.row)"
										type="text" size="small">回执表
									</el-button>

									<!-- <el-button v-if="scope.row.status" @click="handleClick(scope.row,'提醒')" type="text"
										size="small">报名成功提醒
									</el-button> -->
									<!-- <el-button v-if="scope.row.status && scope.row.status === '未确认'" type="text"
										size="small" @click="handleClick(scope.row,'确认报名')">确认报名
									</el-button>
									<el-button v-if="scope.row.status && scope.row.status === '已确认'" type="text"
										size="small" @click="handleClick(scope.row,'取消报名')">取消报名
									</el-button> -->
								</template>
							</el-table-column>
						</elementTable>
					</div>
				</div>
			</div>
			<!-- 确认报名弹窗 -->
			<el-dialog title="提示" :visible.sync="dialogVisible" :width="activeWidth" :before-close="handleClose">
				<div style="display: flex;align-items: center;">
					<div class="el-icon-warning" style="color: #E6A23C;font-size: 25px;"></div>
					<span style="margin-left: 8px;">是否确认参加该报名？</span>
				</div>
				<div class="dialog_midden">
					<span style="margin-right: 20px;margin-left: 34px;">请选择预计到达时间</span>
					<el-date-picker v-model="dateTime" type="date" placeholder="选择日期">
					</el-date-picker>
				</div>
				<span slot="footer" class="dialog-footer">
					<el-button @click="dialogVisible = false">取 消</el-button>
					<el-button type="primary" @click="sureApply">确 定</el-button>
				</span>
			</el-dialog>
			<!-- 提交成功提醒 -->
			<el-dialog title="报名成功提醒" :visible.sync="dialogVisibleNew" :width="newWidth" :before-close="handleCloseNew">
				<div v-html="tipContent" class="contentDetail"></div>
				<span slot="footer" class="dialog-footer">
					<el-button type="primary" @click="dialogVisibleNew = false">确 定</el-button>
				</span>
			</el-dialog>
		</div>
	</div>
</template>

<script>
	import {
		getMeetingDetail,
		getUserList,
		checkSign,
		checkSignVip,
		getUserListVip,
		getNoVipApplyDetil,
		getVipApplyDetail,
		getRuleMessage,
		getNoVipRulemsg,
		getRuleCancle,
		getNoVipCancle
	} from '@/api/moudles/activities.js'
	import {
		API_DOMAIN
	} from "@/api/api.js"
	import mixin from '@/router/mixin'
	import showOne from './components/showOne.vue'
	import showTwo from './components/showTwo.vue'
	import elementTable from '../../../components/elementTable.vue'
	import elementTableExtend from '@/components/elementTableExtend.vue'
	export default {
		mixins: [mixin],
		data() {
			return {
				columNum: 2,
				tipContent: '',
				dialogVisibleNew: false,
				detailShow: false,
				applyDetail: [],
				rowId: '',
				rule_code: '',
				dataShow: false,
				meetingDetail: {},
				meetingLink: [],
				phoneSize: false,
				activeWidth: '30%',
				newWidth: '50%',
				dateTime: '',
				dialogVisible: false,
				indexShow: 0,
				basicShow: true,
				titleList: [{
					label: '基本信息'
				}, {
					label: '联系我们'
				}, {
					label: '已报名信息'
				}],
				outTable: [],
				outTabList: []
			}
		},
		components: {
			showOne,
			showTwo,
			elementTable,
			elementTableExtend
		},
		computed: {
			hasImage() {
				return (value) => {
					if (value && typeof value == 'string') {
						if (value.indexOf('http') != -1) {
							return true
						}
					}
					return false
				}
			}
		},
		created() {
			if (window.location.href.split('?code=').length > 1) {
				const newCode = window.location.href.split('?code=')[1]
				console.log(newCode)
				// this.getMeetingDetail(newCode)
			} else if (this.$route.params.code) {
				const newCode = this.$route.params.code
				// this.getMeetingDetail(newCode)
				console.log(newCode)
			} else {
				this.$router.go(-1)
			}
			if (this.$phoneSize()) {
				this.activeWidth = '98%'
				this.newWidth = '98%'
				this.phoneSize = true
				this.columNum = 1
			} else {
				this.activeWidth = '30%'
				this.newWidth = '50%'
				this.phoneSize = false
				this.columNum = 2
			}
		},
		methods: {
			// 打开回执表
			openApply(row) {
				window.open(`${API_DOMAIN}/adminapi/member/view-receipt?id=${row.id}&meeting_code=${row.meeting_code}`)
			},
			// 关闭成功提醒
			handleCloseNew() {
				this.dialogVisibleNew = false
			},
			// 返回详情
			backToDetail() {
				this.detailShow = false
				this.applyDetail = []
			},
			// 获取非会员报名人员详情
			getApplyDetil(id) {
				if (this.$store.state.user.userVip === false) {
					// 非会员
					getNoVipApplyDetil({
						data: {
							id,
							rule_code: this.rule_code
						},
						success: res => {
							if (res.code === 200) {
								if (res.data) {
									this.detailShow = true
									this.applyDetail = res.data
								}
							} else {
								this.$message.error(res.msg)
							}
						}
					})
				} else {
					getVipApplyDetail({
						data: {
							id,
							rule_code: this.rule_code
						},
						success: res => {
							if (res.code === 200) {
								if (res.data) {
									this.detailShow = true
									this.applyDetail = res.data
								}
							} else {
								this.$message.error(res.msg)
							}
						}
					})
				}
			},
			refreshShow() {
				this.dataShow = false
				if (this.$store.state.user.userVip === true) {
					this.getUserListVip()
				} else {
					this.getUserList()
				}
			},
			// 修改
			changeTab(index) {
				this.indexShow = index
				if (index === 2) {
					this.dataShow = false
					if (this.$store.state.user.userVip === true) {
						// this.getUserListVip()
					} else {
						// this.getUserList()
					}
				}
			},
			// 确认报名
			sureApply() {
				// 验证时间有没有输入在关闭
				// 弹窗
				if (!this.dateTime) {
					this.$message.error('请选择参加该报名的时间')
					return
				} else {
					if (this.$store.state.user.userVip === true) {
						this.checkSignVip(this.rowId, this.dateTime, '2')
					} else {
						this.checkSign(this.rowId, this.dateTime, '2')
					}
				}
			},
			// 确认报名-取消报名
			checkSign(id, join_time, status) {
				checkSign({
					data: {
						id,
						rule_code: this.rule_code,
						join_time,
						status
					},
					success: res => {
						this.dialogVisible = false
						if (res.code === 200) {
							this.$message({
								type: 'success',
								message: res.msg
							});
							this.dateTime = ""
							this.dataShow = false
							this.getUserList()
						} else {
							this.$message.error(res.msg)
						}
					}
				})
			},
			// 会员-报名-取消报名
			checkSignVip(id, join_time, status) {
				checkSignVip({
					data: {
						id,
						rule_code: this.rule_code,
						join_time,
						status
					},
					success: res => {
						this.dialogVisible = false
						if (res.code === 200) {
							this.$message({
								type: 'success',
								message: res.msg
							});
							this.dateTime = ""
							this.dataShow = false
							this.getUserListVip()
						} else {
							this.$message.error(res.msg)
						}
					}
				})
			},
			// 非会员-已报名列表
			getUserList() {
				getUserList({
					data: {
						rule_code: this.rule_code,
					},
					success: res => {
						if (res.data) {
							this.outTabList = res.data.outTabList
							this.outTable = res.data.outTable
							this.dataShow = true
						}
					}
				})
			},
			// 会员-已报名列表
			getUserListVip() {
				getUserListVip({
					data: {
						rule_code: this.rule_code,
					},
					success: res => {
						if (res.data) {
							const outTabList = res.data.outTabList
							this.outTabList = [...Object.values(outTabList)]
							this.outTable = res.data.outTable
							this.dataShow = true
						}
					}
				})
			},
			// 组件一的反馈
			getShowOne(e) {
				this.basicShow = e
				this.$refs.showTwo.startComp(this.rule_code)
			},
			// 回退
			replaceBack() {
				if (this.$phoneSize()) {
					this.$router.replace('/phoneActivitiesList')
				} else {
					this.$router.replace('/activitiesList')
				}
			},
			// 获取会议详情
			getMeetingDetail(meeting_code) {
				getMeetingDetail({
					data: {
						meeting_code
					},
					success: res => {
						// console.log('详情', res)
						this.meetingLink = res.data.link
						this.meetingDetail = res.data
						this.$refs.showOne.setContent(res.data)
						this.rule_code = res.data.rule_code
					}
				})
			},
			handleClose(done) {
				done();
			},
			getTable(e) {
				console.log('e', e)
			},
			handleClick(row, type) {
				this.rowId = row.id
				if (type == '取消报名') {
					this.$confirm('是否确认取消报名', '提示', {
						confirmButtonText: '确定',
						cancelButtonText: '取消',
						type: 'warning'
					}).then(() => {
						if (this.$store.state.user.userVip === true) {
							this.checkSignVip(this.rowId, this.dateTime, '3')
						} else {
							this.checkSign(this.rowId, this.dateTime, '3')
						}
					})
				} else if (type == '确认报名') {
					this.dialogVisible = true
				} else if (type == '提醒') {
					if (this.$store.state.user.userVip === true) {
						getRuleMessage({
							data: {
								rule_code: this.rule_code
							},
							success: res => {
								this.tipContent = res.data
								this.dialogVisibleNew = true
							}
						})
					} else {
						getNoVipRulemsg({
							data: {
								rule_code: this.rule_code
							},
							success: res => {
								this.tipContent = res.data
								this.dialogVisibleNew = true
							}
						})
					}
				} else if (type == '取消') {
					this.$confirm('此操作将取消该会议报名, 是否继续?', '提示', {
						confirmButtonText: '确定',
						cancelButtonText: '取消',
						type: 'warning'
					}).then(() => {
						/* 取消 */
						if (this.$store.state.user.userVip === true) {
							getRuleCancle({
								data: {
									code: row.code,
									rule_code: this.rule_code
								},
								success: res => {
									console.log('会员取消', res)
									this.$message({
										type: 'success',
										message: res.msg
									});
									this.dataShow = false
									this.getUserListVip()
								}
							})
						} else {
							getNoVipCancle({
								data: {
									code: row.code,
									rule_code: this.rule_code
								},
								success: res => {
									console.log('非会员取消', res)
									this.$message({
										type: 'success',
										message: res.msg
									});
									this.dataShow = false
									this.getUserList()
								}
							})
						}
					}).catch(() => {
						this.$message({
							type: 'info',
							message: '已取消'
						});
					});
				} else {
					// 详情
					this.getApplyDetil(row.id)
				}
			},
		}
	}
</script>

<style scoped>
	>>>.contentDetail img,
	.contentDetail p>img,
	.contentDetail span>img {
		max-width: 100%;
	}

	@media screen and (max-width: 750px) {
		.el-popup-parent--hidden {
			overflow: hidden;
			/* padding-right: 0 !important; */
		}

		.phoneStyleTable {
			width: 100%;
			clear: both;
		}

		.dialog_midden span {
			margin: 20px 0;
			display: block;
		}

		.phoneTable {
			width: 100%;
			padding: 10px;
			min-height: 100px;
			border-radius: 10px;
			border: 1px solid #bbb;
			box-sizing: border-box;
			display: flex;
			justify-content: space-between;
		}

		.phoneTable p {
			font-size: 14px;
			line-height: 30px;
		}

		.phoneTable span {
			color: #c22c25;
			font-size: 14px;
		}

		.phoneStyle {
			width: calc(100% - 20px);
			margin-left: 10px;
			margin-bottom: 10px;
		}

		.phoneStyle p {
			font-size: 16px;
			margin-bottom: 10px;
		}

		.phoneStyle img {
			width: 100%;
			height: 158px;
			object-fit: cover;
			border-radius: 7px;
		}

		.activityPerson {
			width: 100%;
			background-color: #fff;
			min-height: calc(100vh - 60px);
		}

		.activity_body {
			display: flex;
			flex-flow: column;
			justify-content: space-between;
			padding-top: 20px;
		}

		.activityPerson_right {
			width: 100%;
			min-height: 600px;
			padding: 0 10px;
			box-sizing: border-box;
			margin-bottom: 60px;
			padding-bottom: 40px;
		}

		.activityPerson_left {
			display: none;
		}

		.phoneMode {
			display: flex;
			justify-content: space-evenly;
			border-bottom: 1px solid #f5f5f5;
			margin-bottom: 10px;
		}

		.phoneView {
			height: 40px;
		}

		.phoneView p {
			padding: 5px 10px;
			display: inline-block;
			background-color: #ffdfdf;
		}

		.phoneModeActive {
			border-bottom: 3px solid #3e86fe;
		}

		.bottom_btnList {
			display: flex;
			justify-content: flex-end;
			margin: 20px 0;
		}

		.phoneTable_pList {
			display: grid;
			grid-template-columns: repeat(2, 1fr);
			grid-column-gap: 10px;
		}

		.bottom_btnList p {
			text-align: center;
			color: #409eff;
			margin-left: 20px;
		}
	}

	@media screen and (min-width: 750px) {
		.phoneStyle {
			display: none;
		}

		.dialog_midden {
			margin-top: 20px;
		}

		.activityPerson {
			width: 1200px;
			margin: 0 auto;
			background-color: #fff;
			min-height: calc(100vh - 260px);
		}

		.activity_body {
			display: flex;
			justify-content: space-between;
			padding-top: 20px;
		}

		.activityPerson_right {
			width: 980px;
			min-height: 600px;
			padding-right: 20px;
			padding-bottom: 40px;
		}

		.activityPerson_left {
			width: 170px;
			text-align: center;
		}

		.phoneMode {
			display: none;
		}
	}




	.activityPerson_left p {
		box-sizing: border-box;
		display: block;
		height: 50px;
		line-height: 50px;
	}

	.activityPerson_left p:hover {
		cursor: pointer;
		opacity: 0.7;
	}

	.activePerson {
		background-color: #f5f5f5;
		border-right: 2px solid royalblue;
	}

	.brumd_card {
		width: 100%;
		height: 60px;
		line-height: 60px;
		font-size: 14px;
		padding-left: 20px;
		border-bottom: 2px solid #f5f5f5;
		box-sizing: border-box;
	}

	.brumd_card span {
		cursor: pointer;
	}
</style>